/** Shared assets for product UI widgets (how-it-works steps, etc.). */
export const PRODUCT_WIDGET_ASSETS = {
  shopify1: "/assets-next/growing/how-it-works/shopify-logo-part1.svg",
  shopify2: "/assets-next/growing/how-it-works/shopify-logo-part2.svg",
  shopify3: "/assets-next/growing/how-it-works/shopify-logo-part3.svg",
  amazon: "/assets-next/growing/how-it-works/amazon-logo.svg",
  cursor: "/assets-next/growing/how-it-works/cursor-pointer.svg",
} as const;
